import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic';
import { PageEnum } from '/@/enums/pageEnum';
import { mainOutRoutes } from '/@/router/routes/mainOut';
import { t } from '/@/hooks/web/useI18n';
// import { opRoutes } from './modules/op';
import bigScreenRoutes from './modules/bigScreen';

const modules = import.meta.globEager('./modules/op.ts');
const routeModuleList: AppRouteModule[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('/@/views/sys/login/Login.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};

export const DeviceConfigNetNormalRoute: AppRouteRecordRaw = {
  path: '/tools/confignet',
  name: 'Device-Config-Net',
  component: () => import('/@/views/op/tools/index.vue'),
  meta: {
    title: '设备配网',
    ignoreAuth: true,
  },
};

// Basic routing without permission
// 未经许可的基本路由
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  DeviceConfigNetNormalRoute,
  ...mainOutRoutes,
  ...bigScreenRoutes,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
];
